"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var equality_1 = require("@wry/equality");
exports.isEqual = equality_1.equal;
//# sourceMappingURL=isEqual.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/apollo-utilities/lib/util/isEqual.js
// module id = mslX
// module chunks = 25